import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import { useSvgId } from 'src/lib/hooks';

export const IconChannelMicrosoftDynamics = memo(
  forwardRef((props, ref) => {
    const svgId = useSvgId();
    const svgId2 = useSvgId();
    const svgId3 = useSvgId();

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          d="M10.5 24C16.299 24 21 19.299 21 13.5C21 7.70101 16.299 3 10.5 3C4.70101 3 0 7.70101 0 13.5C0 19.299 4.70101 24 10.5 24Z"
          fill={`url(#${svgId})`}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9221 13.3924C23.9748 12.9356 24.002 12.471 24.002 12C24.002 5.37257 18.6294 0 12.002 0C11.531 0 11.0664 0.0271298 10.6096 0.0799118C10.2523 0.232457 10.002 0.58699 10.002 1V14H23.002C23.415 14 23.7695 13.7496 23.9221 13.3924Z"
          fill={`url(#${svgId2})`}
        />
        <path
          d="M10.002 7.5H15.502C16.0542 7.5 16.502 7.94772 16.502 8.5V14H10.002V7.5Z"
          fill={`url(#${svgId3})`}
        />
        <defs>
          <linearGradient
            id={svgId}
            x1="7.7087"
            y1="10.0882"
            x2="14.7253"
            y2="23.1896"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0078D4" />
            <stop
              offset="1"
              stopColor="#2064AE"
            />
          </linearGradient>
          <linearGradient
            id={svgId2}
            x1="14.002"
            y1="2.375"
            x2="27.298"
            y2="14.4333"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#40C4F5" />
            <stop
              offset="1"
              stopColor="#0095E6"
            />
          </linearGradient>
          <linearGradient
            id={svgId3}
            x1="10.4768"
            y1="7.55275"
            x2="13.2316"
            y2="14.5075"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A7F2FF" />
            <stop
              offset="1"
              stopColor="#7CECFF"
            />
          </linearGradient>
        </defs>
      </SvgIcon>
    );
  })
);
